<template>
  <div class="main-content">
    <div class="content-left">
      <div class="dialer-section">
        <div class="dialer-input">
          <dial-pad v-model="calleeNumber"  @queryCallRecords="queryCallRecords" />
        </div>
      </div>
    </div>

    <div class="content-right">
      <!-- 今日话单 -->
      <div class="call-list">
        <div class="list-title">今日话单</div>
        <el-table
          :data="callRecords"
          style="width: 100%"
          :header-cell-style="{
            background: '#DAE3FF',
            color: '#2B4B75',
            fontWeight: '500',
            fontSize: '14px',
            height: '48px',
            padding: '0',
            borderBottom: '1px solid #E4E7ED',
          }"
          :cell-style="{
            color: '#2B4B75',
            fontSize: '14px',
            padding: '16px 0',
          }"
          :row-style="{
            height: '56px',
          }"
        >
          <el-table-column
            prop="caller"
            label="坐席账号"
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="callee"
            label="被叫号码"
            min-width="120"
            align="center"
          ></el-table-column>
          <!-- <el-table-column
            prop="calledCityCode"
            label="被叫归属地"
            min-width="120"
            align="center"
          ></el-table-column> -->
          <el-table-column
            prop="beginTime"
            label="呼叫时间"
            min-width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.beginTime) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="chargeCallTime"
            label="通话时长"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatDuration((new Date(scope.row.endTime) - new Date(scope.row.calleeRingTime)) / 1000) }}
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="hangupCause"
            label="挂机原因"
            min-width="120"
            align="center"
          ></el-table-column> -->
          <!-- <el-table-column fixed="right" label="更多" width="80" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="showCallDetail(scope.row)">
                <span class="more-text">查看详情</span>
              </el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </div>

    <!-- 添加详情弹窗 -->
    <call-detail :visible.sync="showDetailDialog" :detail="currentDetail" />
  </div>
</template>

<script>
import DialPad from "./DialPad.vue";
import CallDetail from "./CallDetail.vue";
import { formatDateTime, formatDuration } from "@/utils/format";

export default {
  name: "CallContent",
  components: {
    DialPad,
    CallDetail,
  },
  data() {
    return {
      calleeNumber: "",
      callRecords: [],
      showDetailDialog: false,
      currentDetail: null,
      callButtonText: '呼叫',
      callButtonType: 'primary',
      currentSession: null,
      page: 1,
      limit: 5,
      searchDate: new Date().toISOString().split('T')[0], // 默认今天
      userInfo: {},

    };
  },
  methods: {
    formatDateTime,
    formatDuration,
    showCallDetail(row) {
      this.currentDetail = row;
      this.showDetailDialog = true;
    },
    async queryCallRecords() {
      const records = JSON.parse(localStorage.getItem(this.userInfo.phoneNumber) || '[]');
      // 按日期时间倒序排序（最新的记录在前）
      this.callRecords = records.slice(0,5).sort((a, b) => new Date(b.beginTime) - new Date(a.beginTime));
    },

    getCallStatus(callStatus) {
      switch (callStatus) {
        case 1:
          return "处理中";
        case 2:
          return "已接听";
        case 3:
          return "振铃中";
        case 4:
          return "通话中";
        case 5:
          return "呼叫失败";
        case 0:
          return "通话结束";
        default:
          return "未知状态";
      }
    },
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.queryCallRecords();
    
  },
};
</script>

<style lang="less" scoped>
.main-content {
  flex: 1;
  display: flex;
  flex-direction: row;
  padding: 0 20px 20px;
  background: white;
}

.content-left {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.content-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.dialer-section {
  padding: 20px;
  border-radius: 8px;
}

.dialer-input {
  display: flex;
  justify-content: center;
}

.call-list {
  flex: 1;
  padding: 20px;
  border-radius: 24px;
  background: white;
}

.list-title {
  font-size: 24px;
  font-weight: 500;
  color: #2b4b75;
  margin-bottom: 24px;
  text-align: left;
}

.more-text {
  color: #5579e7;
  font-size: 14px;
}

:deep(.el-table) {
  &::before {
    display: none;
  }

  .el-table__header-wrapper {
    border-radius: 0;
    overflow: hidden;
  }

  .el-table__body-wrapper {
    overflow-x: hidden;

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: #e4e7ed;
    }

    &::-webkit-scrollbar-track {
      border-radius: 3px;
      background: #f5f7fa;
    }
  }

  .el-table__fixed-right::before,
  .el-table__fixed::before {
    display: none;
  }

  .el-table__row {
    &:hover > td {
      background-color: #f1f5ff !important;
    }
  }
}
</style>
